import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Button, Icon } from './atoms';

const template = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ icon }) => !!icon,
      displayValue: ({ icon }) => icon
    },
    {
      component: Button,
      name: 'Button',
      displayValue: ({ title }) => title,
      displayState: ({ disabled, mobileSmall, selected }) => ({ disabled, mobileSmall, selected }),
    },
  ]
})